var _mask, _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4381_2800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5.99994L13.2501 0H2C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.895431 24 2 24H17C18.1046 24 19 23.1046 19 22V5.99994ZM18 6.00006L13 1V5.50006C13 5.7762 13.2239 6.00006 13.5 6.00006H18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 0L13.9721 -0.691902L13.6768 -1H13.2501V0ZM19 5.99994H20V5.59814L19.722 5.30804L19 5.99994ZM13 1L13.7071 0.292897L12 -1.41423V1H13ZM18 6.00006V7.00006H20.4142L18.7071 5.29295L18 6.00006ZM12.5281 0.691902L18.278 6.69184L19.722 5.30804L13.9721 -0.691902L12.5281 0.691902ZM2 1H13.2501V-1H2V1ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343146 -1 -1 0.343145 -1 2H1ZM1 22V2H-1V22H1ZM2 23C1.44772 23 1 22.5523 1 22H-1C-1 23.6569 0.343146 25 2 25V23ZM17 23H2V25H17V23ZM18 22C18 22.5523 17.5523 23 17 23V25C18.6569 25 20 23.6569 20 22H18ZM18 5.99994V22H20V5.99994H18ZM12.2929 1.7071L17.2929 6.70716L18.7071 5.29295L13.7071 0.292897L12.2929 1.7071ZM14 5.50006V1H12V5.50006H14ZM13.5 5.00006C13.7761 5.00006 14 5.22391 14 5.50006H12C12 6.32848 12.6716 7.00006 13.5 7.00006V5.00006ZM18 5.00006H13.5V7.00006H18V5.00006Z",
    fill: "#D91F05",
    mask: "url(#path-1-inside-1_4381_2800)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 13,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    width: 15,
    height: 1,
    rx: 0.5,
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.8fc19a9b082311e98daf93f559b41034.svg";
export { ForwardRef as ReactComponent };